(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/create-game/assets/javascripts/draw-selection.js') >= 0) return;  svs.modules.push('/components/marketplace/create-game/assets/javascripts/draw-selection.js');
"use strict";


const {
  useCallback,
  useState,
  useEffect,
  useRef
} = React;
const {
  useSelector,
  useDispatch
} = ReactRedux;
const {
  useParams,
  useLocation,
  useHistory
} = ReactRouterDOM;
const {
  DropdownSelectItem,
  DropdownItem,
  DropdownLabel
} = svs.ui.ReactDropdown;
const {
  formatDate
} = svs.components.lbUtils.helpers.formatDate;
const {
  format: {
    Currency: formatCurrency
  }
} = svs.utils;
const {
  getDraw
} = svs.components.marketplaceData.selectors.draws;
const {
  selectDraw
} = svs.components.marketplaceData.createGame.actions;
const {
  getDrawItems
} = svs.components.marketplaceData.createGame.helpers;
const {
  resolveProductId
} = svs.utils.products;
const {
  JackPotAndFunds
} = svs.components.lbUi.jackpotAndFunds.JackPotAndFunds;
const {
  getProductItems
} = svs.components.marketplaceData.createGame.helpers;
const DrawItemInfo = _ref => {
  let {
    item,
    isEdit,
    className = '',
    showNetSale = false
  } = _ref;
  const ariaLabel = "".concat(item.name, " Spelstopp ").concat(formatDate(new Date(item.regCloseTime)));
  if (isEdit) {
    return React.createElement("p", {
      "aria-label": ariaLabel,
      className: "f-200 select-draw-line-height ".concat(className).trim(),
      role: "text"
    }, React.createElement("span", {
      "aria-hidden": "true",
      className: "draw-selection-item-name qa-draw-selection-item-name"
    }, "".concat(item.name, " Spelstopp ").concat(formatDate(new Date(item.regCloseTime), true, true, false))));
  }
  return React.createElement("p", {
    "aria-label": ariaLabel,
    className: "f-200 select-draw-line-height ".concat(className).trim(),
    role: "text"
  }, React.createElement("span", {
    "aria-hidden": "true",
    className: "f-medium f-uppercase draw-selection-item-name qa-draw-selection-item-name"
  }, item.name), React.createElement("span", {
    "aria-hidden": "true",
    className: "f-normal overflow-threedots"
  }, "Spelstopp ".concat(formatDate(new Date(item.regCloseTime), true, true, false))), showNetSale && React.createElement(React.Fragment, null, React.createElement("br", null), React.createElement("span", {
    className: ""
  }, "Oms\xE4ttning: ".concat(formatCurrency(item.currentNetSale), " kr"))));
};
const DrawSelection = () => {
  const dispatch = useDispatch();
  const {
    activatedDrawId
  } = useParams();
  const location = useLocation();
  const history = useHistory();
  const [productItems, setProductItems] = useState();
  const [localSelectedDraw, setLocalSelectedDraw] = useState(null);
  const prevProductItemsRef = useRef();
  const hasInitializedRef = useRef(false);

  const queryParams = new URLSearchParams(location.search);
  const queryDrawNumber = queryParams.get('drawNumber');
  const {
    draws
  } = useSelector(state => state.Draws);
  const {
    isSelectedDrawClosed,
    selectedDraw,
    selectedProduct
  } = useSelector(state => state.CreateGame || {});

  useEffect(() => {
    if (!hasInitializedRef.current) {
      if (queryDrawNumber) {
        setLocalSelectedDraw(parseInt(queryDrawNumber, 10));
        hasInitializedRef.current = true;
      } else if (selectedDraw !== 0 && selectedDraw !== undefined) {
        setLocalSelectedDraw(selectedDraw);
        hasInitializedRef.current = true;
      } else if (selectedProduct && draws[selectedProduct] && !selectedDraw && !queryDrawNumber) {
        const drawItems = getDrawItems(draws[selectedProduct]);
        const firstAvailableDraw = drawItems.find(_ref2 => {
          let {
            isDisabled
          } = _ref2;
          return !isDisabled;
        });
        if (firstAvailableDraw) {
          setLocalSelectedDraw(firstAvailableDraw.item.drawNumber);
          hasInitializedRef.current = true;
        }
      }
    }
  }, [selectedDraw, queryDrawNumber, selectedProduct, draws]);

  useEffect(() => {
    hasInitializedRef.current = false;
  }, [selectedProduct]);
  const draw = useSelector(state => getDraw(state, {
    drawNumber: localSelectedDraw || (queryDrawNumber ? parseInt(queryDrawNumber, 10) : selectedDraw),
    productName: selectedProduct
  }));
  const onSelectDraw = useCallback(drawNumber => {
    const drawItems = getDrawItems(draws[selectedProduct]);
    const isDrawDisabled = drawItems.some(_ref3 => {
      let {
        item,
        isDisabled
      } = _ref3;
      return drawNumber === item.drawNumber && isDisabled;
    });
    if (!isDrawDisabled) {
      setLocalSelectedDraw(drawNumber);
      dispatch(selectDraw(drawNumber));
    }
    if (queryDrawNumber) {
      const newParams = new URLSearchParams(location.search);
      newParams.set('drawNumber', String(drawNumber));
      const newSearch = newParams.toString();
      history.replace({
        pathname: history.location.pathname,
        search: newSearch ? "?".concat(newSearch) : '',
        hash: history.location.hash
      });
    }
  }, [draws, dispatch, selectedProduct, history, location.search, queryDrawNumber]);
  useEffect(() => {
    let isMounted = true;
    const fetchProductItems = async () => {
      const currentProductItems = await getProductItems({
        allProductNames: [selectedProduct],
        drawsByProduct: draws
      });
      if (isMounted && (!prevProductItemsRef.current || JSON.stringify(prevProductItemsRef.current) !== JSON.stringify(currentProductItems))) {
        setProductItems(currentProductItems);
      }
      prevProductItemsRef.current = currentProductItems;
    };
    fetchProductItems();
    return () => {
      isMounted = false;
    };
  }, [selectedProduct, draws]);
  if (activatedDrawId) {
    return draw ? React.createElement(DrawItemInfo, {
      className: "margin-bottom-1",
      isEdit: true,
      item: draw
    }) : null;
  }
  const drawItems = getDrawItems(draws[selectedProduct]);
  const currentSelectedDraw = localSelectedDraw || (queryDrawNumber ? parseInt(queryDrawNumber, 10) : selectedDraw);
  const selectedDrawIndex = drawItems.findIndex(_ref4 => {
    let {
      item,
      isDisabled
    } = _ref4;
    return currentSelectedDraw === item.drawNumber || !currentSelectedDraw && !isDisabled;
  });
  if (selectedDrawIndex === -1) {
    return null;
  }
  const otherAvailableDrawItems = drawItems.filter((_ref5, index) => {
    let {
      isDisabled
    } = _ref5;
    return index !== selectedDrawIndex && !isDisabled;
  });
  if (otherAvailableDrawItems.length === 0) {
    return React.createElement(DrawItemInfo, {
      className: "padding-xs-top padding-xs-bottom",
      item: drawItems[selectedDrawIndex].item,
      showNetSale: true
    });
  }
  if (!productItems) {
    return null;
  }
  return React.createElement("div", {
    className: "control-group ".concat(isSelectedDrawClosed ? 'selected-draw-closed' : ''),
    "data-testid": "draw-selection"
  }, React.createElement(DropdownSelectItem, {
    className: "select-draw-list",
    onSelect: onSelectDraw,
    v2: true
  }, drawItems.map((_ref6, index) => {
    let {
      item,
      isDisabled,
      disabledReason
    } = _ref6;
    const {
      item: productName,
      jackpots = [],
      funds = []
    } = productItems[0];
    const productId = resolveProductId(productName);
    const hasJackpotOrFunds = jackpots.length > 0 || funds.length > 0;
    return React.createElement(DropdownItem, {
      disabled: isDisabled,
      key: "".concat(item.key, "_").concat(item.name, "_").concat(item.regCloseTime),
      name: item.drawNumber,
      selected: index === selectedDrawIndex
    }, React.createElement(DrawItemInfo, {
      item: item
    }), Boolean(isDisabled) && React.createElement(DropdownLabel, {
      right: true
    }, React.createElement("div", {
      className: "qa-draw-selection-disabled-reason"
    }, disabledReason)), React.createElement(DropdownLabel, {
      right: true
    }, React.createElement("div", {
      className: "draw-selection-right-content"
    }, hasJackpotOrFunds && React.createElement("div", {
      className: "draw-selection-jackpot-funds"
    }, React.createElement(JackPotAndFunds, {
      drawNumber: item.drawNumber,
      funds: funds,
      jackpots: jackpots,
      productId: productId
    })), React.createElement("div", {
      className: "draw-selection-net-sale f-200"
    }, "Oms\xE4ttning: ".concat(formatCurrency(item.currentNetSale), " kr")))));
  })));
};
setGlobal('svs.components.marketplace.createGame.DrawSelection', DrawSelection);

 })(window);